export default "__VITE_ASSET__DgocDbiR__"